import api from './api';

const FILE_SHARING_BASE = '/file-sharing';

export const fileSharingService = {
  // Get all files
  getAll: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.search) params.append('search', filters.search);
    if (filters.sharedWith) params.append('sharedWith', filters.sharedWith);
    if (filters.folderId !== undefined) params.append('folderId', filters.folderId);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);

    const queryString = params.toString();
    return api.get(`${FILE_SHARING_BASE}/files${queryString ? `?${queryString}` : ''}`);
  },

  // Get single file by ID
  getById: (id) => api.get(`${FILE_SHARING_BASE}/files/${id}`),

  // Upload new file
  upload: (formData) => {
    return api.post(`${FILE_SHARING_BASE}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Update file metadata
  update: (id, fileData) => api.put(`${FILE_SHARING_BASE}/files/${id}`, fileData),

  // Delete file
  delete: (id) => api.delete(`${FILE_SHARING_BASE}/files/${id}`),

  // Download file
  download: (id) => api.get(`${FILE_SHARING_BASE}/files/${id}/download`, {
    responseType: 'blob',
  }),

  // Share file with users
  share: (id, shareData) => api.post(`${FILE_SHARING_BASE}/files/${id}/share`, shareData),

  // Get shared users for a file
  getSharedUsers: (id) => api.get(`${FILE_SHARING_BASE}/files/${id}/shared-users`),

  // Get storage stats
  getStats: () => api.get(`${FILE_SHARING_BASE}/stats`),

  // Create folder
  createFolder: (folderData) => api.post(`${FILE_SHARING_BASE}/folders`, folderData),

  // Rename file or folder
  rename: (id, name) => api.patch(`${FILE_SHARING_BASE}/files/${id}/rename`, { name }),

  // Move file or folder to different parent folder
  move: (id, parentFolderId) => api.patch(`${FILE_SHARING_BASE}/files/${id}/move`, { parentFolderId }),
};

export default fileSharingService;
